import React, { createContext, useReducer, useEffect, useRef, useContext } from "react";
import { reducer, initialState } from "./reducers";
import { useActions } from "./actions";
import { setLocalStorage } from "../helpers";
import { usePrevious } from "../hooks";

const StoreContext = createContext(initialState);

const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const actions = useActions(state, dispatch);
    const didMountRef = useRef(false);
    const prevUser = usePrevious(state.user);
    const prevMonitoring = usePrevious(state.monitoring);
    const prevHerd = usePrevious(state.herd);
    const prevObjects = usePrevious(state.objects);
    const prevCowSearch = usePrevious(state.cowSearch);
    const prevSort = usePrevious(state.sort);
    const prevGroup = usePrevious(state.group);
    const prevCowsList = usePrevious(state.cowsList);
    const prevGroupsList = usePrevious(state.groupsList);
    const prevZonesList = usePrevious(state.zonesList);
    const prevTimestamp = usePrevious(state.timestamp);

    useEffect(() => {
        if (didMountRef.current) {
            if (process.env.REACT_APP_VERSION !== 'DEMO') {
                if (state.user !== prevUser) {
                    setLocalStorage('user', state.user)
                }
                if (state.monitoring !== prevMonitoring) {
                    setLocalStorage('monitoring', state.monitoring)
                }
                if (state.herd !== prevHerd) {
                    setLocalStorage('herd', state.herd)
                }
                if (state.objects !== prevObjects) {
                    setLocalStorage('objects', state.objects)
                }
                if (state.cowSearch !== prevCowSearch) {
                    setLocalStorage('cowSearch', state.cowSearch)
                }
                if (state.sort !== prevSort) {
                    setLocalStorage('sort', state.sort)
                }
                if (state.group !== prevGroup) {
                    setLocalStorage('group', state.group)
                }
                if (state.cowsList !== prevCowsList) {
                    setLocalStorage('cowsList', state.cowsList)
                }
                if(state.groupsList !== prevGroupsList) {
                    setLocalStorage('groupsList', state.groupsList)
                }
                if(state.zonesList !== prevZonesList) {
                    setLocalStorage('zonesList', state.zonesList)
                }
                if(state.timestamp !== prevTimestamp) {
                    setLocalStorage('timestamp', state.timestamp)
                }
            }
        }
        else {
            didMountRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    return (
        <StoreContext.Provider value={{ state, dispatch, actions }}>
            {children}
        </StoreContext.Provider>
    );
};

const Store = () => useContext(StoreContext);

export { StoreProvider, Store };